exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Sidebar background color */\n/* Sidebar header and footer color */\n/* Sidebar title text colour */\n/* Sidebar menu item hover color */\n.texts-danger {\n  color: #F68C1F; }\n\n.texts-success {\n  color: #00A85F; }\n\n.text-stop {\n  color: #ED1C24; }\n\n.spog-spinner {\n  margin: auto; }\n  .spog-spinner.sk-spinner {\n    color: #70727f; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/style/components/ui/loading/spog-spinner.scss
// module id = 926
// module chunks = 49